module.exports = "/images/about_logo_gdpr_compliant.svg?5550dca134cb31e307f47eeeb39e05fb";